import { DEFAULT_EMPTY_SYMBOL, DECLINATION_OF_MONTHS } from '../../constants';

import { getUTCDateTime } from './get-utc-date-time';

type TDateFormat = 'short' | 'long';

/** Форматирует ISO дату (без часового пояса) из формата YYYY-MM-DD в заданный формат: short (DD.MM.YYYY) или long (DD month YYYY) */
export const formatISODateToString = (
    dateString?: string | null,
    format: TDateFormat = 'short'
): string => {
    if (!dateString) {
        return DEFAULT_EMPTY_SYMBOL;
    }

    const { utcDate, utcMonth, utcMonthFull, utcYear } = getUTCDateTime(dateString);

    if ([utcDate, utcMonth, utcYear].some(isNaN)) {
        return DEFAULT_EMPTY_SYMBOL;
    }

    switch (format) {
        case 'long':
            return `${utcDate} ${DECLINATION_OF_MONTHS[utcMonth]} ${utcYear}`;
        case 'short':
        default:
            return `${utcDate}.${utcMonthFull}.${utcYear}`;
    }
};
